module.exports = __webpack_public_path__ + "static/media/world.ec3c8819.svg";